module.exports = __webpack_public_path__ + "static/media/merci-alfred.081caf5f.png";